<template>
  <div class="flex flex-center q-pa-md" style="height: 100vh;">

    <q-drawer v-model="drawerLeft" :width="500" behavior="mobile" bordered>
      <q-scroll-area class="fit">
        <div class="q-pa-sm">
          <q-list bordered color="primary" class="rounded-borders text-primary" style="max-width: 500px">
            <q-item-label header>Historial</q-item-label>

            <q-item bordered   v-ripple v-for="item of historial" :key="item._id"
             >
              <q-item-section>
                <q-item-label lines="1">{{ item.estado }}</q-item-label>
                <q-item-label caption lines="2">
                  <span class="text-weight-bold">{{ item.referencia }}</span>

                </q-item-label>
              </q-item-section>

              <q-item-section side top>
                {{ FormatDate(item.fechacreacion) }} <br />
                <b>{{ formatCurrency(item.montocobrado) }} </b>
              </q-item-section>

              <q-item-section side top>
                <div class="text-grey-8 q-gutter-xs">
                    <q-btn color="primary" flat dense round icon="mdi-printer"  @click="reImprimirHistorial(item)"/>
                </div>
              </q-item-section>

              <!-- <q-item-section side top>
                <div class="text-grey-8 q-gutter-xs" v-if="item.estado != 'Cancelado'">
                    <q-btn v-if="EsHoy(item.fechacreacion)" color="red" flat  dense round icon="delete" @click="CancelarMovimiento(item)" />
                    <q-btn color="primary" flat dense round icon="mdi-printer"  @click="reImprimirHistorial(item)"/>
                </div>
              </q-item-section> -->
              </q-item>

            

            <q-separator inset="item" />
          </q-list>
        </div>
      </q-scroll-area>
    </q-drawer>

    <q-dialog v-model="confirmPago" persistent>
      <q-card style="width:350px;">
        <q-card-section class="row items-center justify-center q-mt-md" v-if="loadingReimprimir == false">
          <q-avatar size="150px" font-size="150px" icon="mdi-check-circle" color="primary" text-color="white" />
          <div class="text-primary text-center text-h5">{{ mensajeCorrecto }}</div>
        </q-card-section>
        <q-card-actions align="right" v-if="loadingReimprimir == false">
          <q-btn flat label="RE-IMPRIMIR" color="primary" @click="ReprintXFolio()" />
          <q-btn flat label="ACEPTAR" color="primary" v-close-popup />
        </q-card-actions>
        <q-card-section v-if="loadingReimprimir == true">
          <div class="text-center q-my-lg">
            <q-spinner-facebook size="100px" color="light-blue" />
            <div class="trxt-primary">Esperando pago...</div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog v-model="confirmPagoError" persistent>
      <q-card style="width:350px;">
        <q-card-section class="row items-center justify-center q-mt-md" v-if="loadingReimprimir == false">
          <q-avatar size="150px" font-size="150px" icon="mdi-alert-circle" color="red" text-color="white" />
          <div class="text-red  text-center text-h5">{{ mensajeError }}</div>
        </q-card-section>
        <q-card-actions align="right" v-if="loadingReimprimir == false">
          <q-btn flat label="RE-IMPRIMIR" color="primary" @click="ReprintXFolio()" />
          <q-btn flat label="ACEPTAR" color="primary" v-close-popup />
        </q-card-actions>
        <q-card-section v-if="loadingReimprimir == true">
          <div class="text-center q-my-lg">
            <q-spinner-facebook size="100px" color="light-blue" />
            <div class="trxt-primary">Esperando pago...</div>
          </div>
        </q-card-section>
      </q-card>

    </q-dialog>

    <q-card class="q-pa-md " style="width: 600px;">
      <q-card-section v-if="loadingBtnCobro == false">
        <div class="text-center">
          <div class="row justify-between text-bold">
            <div class="text-h6" style="color: #1F3664;">Información de Pago</div>
            <img src="../assets/netpay.png" alt="" height="auto" width="60" class="q-my-sm">
          </div>
          <q-separator />
          <q-form @submit="CrearCobroSpin()">
            <div class="q-mt-lg ">
              <q-field input-class="text-right" filled label="Monto a Pagar" stack-label>
                <template v-slot:control>
                  <div class="text-right self-center full-width no-outline" tabindex="0">{{ montoFormated }}</div>
                </template>
              </q-field>

              <div class="row text-right justify-end" v-if="modo== 'pruebas' && monto >= 300">
                <q-checkbox v-model="aplicaMeses" label="Meses sin Intereses" />
              </div>

              <q-select v-if="aplicaMeses" filled outlined v-model="msi" class=" q-mb-md" :options="optionsMeses"
                label="Meses sin Intereses" option-label="label" option-value="value" emit-value map-options />

              <!-- <q-input filled v-model="monto" label="Monto a Pagar" mask="#.##" fill-mask="0" reverse-fill-mask
                input-class="text-right" class="q-mb-lg" /> -->
              <div v-if="msi == '18'" class="  doc-note text-left">
                <p class="doc-note__title">Aviso</p>
                <p class="">No valido para American Express</p>
              </div>

              <q-btn class="full-width" color="primary" type="submit" label="Cobrar" :loading="loadingBtnCobro" />
            </div>
          </q-form>
          <img src="../assets/netpay.png" alt="" width="60" class="q-mt-md">
        </div>
      </q-card-section>
      <q-card-section v-else>
        <div class="text-center q-my-lg">
          <q-spinner-facebook size="100px" color="light-blue" />
          <div class="trxt-primary">Esperando pago...</div>
        </div>

        <div class="text-right">
          <q-btn flat color="primary" label="Cancelar" @click="cancelarCobro()" />
        </div>
      </q-card-section>
    </q-card>

    <q-page-sticky position="top-left" :offset="[18, 18]">
      <q-btn fab icon="mdi-format-list-bulleted" color="primary" @click="verHistorial()" />
    </q-page-sticky>

  </div>
</template>
<script>
import axios from "axios";
import { QSpinnerFacebook } from 'quasar'
import { format } from 'date-fns';
import { parse } from 'date-fns';
import { endOfMonth } from 'date-fns';
import { es } from 'date-fns/locale';
import CryptoJS from "crypto-js";
export default {
  name: 'Home',
  components: {
  },
  data() {
    return {
      parametros: {},
      monto: 0,
      loadingBtnCobro: false,
      confirmPago: false,
      confirmPagoError: false,
      referencia: '',
      sistema: '',
      loadingReimprimir: false,
      mensajeError: '',
      mensajeCorrecto: '',
      drawerLeft: false,
      historial: [],
      terminal: '',
      id_usuario: '',
      montoFormated: '',
      id_venta: '',
      modo: '',

      optionsMeses: [
        { label: '3 MESES', value: '03' },
        { label: '6 MESES', value: '06' },
        { label: '9 MESES', value: '09' },
        { label: '12 MESES', value: '12' },
        { label: '18 MESES', value: '18' },
      ],
      aplicaMeses: false,
      msi: '',
      cadena: '',
      cadenades: '',
    }
  },
  mounted() {

    // FUNCION PARA ENCRIPTAR
    // const CryptoJS = require('crypto-js');
    // const secretKey = 'id_key_25188289830176';
    // const params = "modo=productivo&monto=0.01&id_usuario=689a8764813ae823af65e47b&sistema=monedero&terminal=2841347834&id_venta=123456789";

    // const params = "modo=pruebas&monto=400&id_usuario=689a8764813ae823af65e47b&sistema=monedero&terminal=2840400319&id_venta=aaa233aa23";
    // const encrypted = CryptoJS.AES.encrypt(params, secretKey).toString();
    // const url = `https://terminalesnetpay.contago.com.mx/?params=${encodeURIComponent(encrypted)}`;
    // console.log(url);

    const encryptedParams = this.getUrlParameter('params');
    if (encryptedParams) {
      const decrypted = this.decryptParams(encryptedParams);
      this.cadenades = this.decryptParams(encryptedParams);
      const params = this.parseParams(decrypted);
      this.monto = parseFloat(params.monto);
      this.id_usuario = params.id_usuario;
      this.montoFormated = this.formatoMonedaMexicana(params.monto);
      this.sistema = params.sistema;
      this.terminal = params.terminal;
      this.id_venta = params.id_venta;
      this.modo = params.modo;
    }

    this.cadena = encryptedParams

    // this.monto = parseFloat(this.$route.query.monto);
    // this.id_usuario = this.$route.query.id_usuario
    // this.montoFormated = this.formatoMonedaMexicana(this.$route.query.monto);
    // this.sistema = this.$route.query.sistema;
    // this.terminal = this.$route.query.terminal;
    // this.id_venta = this.$route.query.id_venta;
    // this.modo = this.$route.query.modo;

    // console.log(this.id_usuario, this.monto, this.id_usuario, this.sistema, this.terminal, this.id_venta)

  },
  computed: {

  },
  created() {
    // const modo = this.$route.query.modo
    // const monto =  parseFloat(this.$route.query.monto)
    // const idUsuario = this.$route.query.id_usuario
    // const sistema = this.$route.query.sistema
    // const terminal = this.$route.query.terminal
    // const idVenta = this.$route.query.id_venta


  },
  methods: {
    getUrlParameter(name) {
      const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      const results = regex.exec(window.location.href);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    },
    decryptParams(encryptedParams) {
      const secretKey = 'id_key_25188289830176';
      const bytes = CryptoJS.AES.decrypt(encryptedParams, secretKey);
      return bytes.toString(CryptoJS.enc.Utf8);
    },
    parseParams(paramString) {
      const params = {};
      const pairs = paramString.split('&');
      pairs.forEach(pair => {
        const [key, value] = pair.split('=');
        params[key] = value;
      });
      return params;
    },
    async reImprimirHistorial(item) {
      this.drawerLeft = false
      let intentos = 0;
      const maxIntentos = 240;
      this.$q.loading.show({ spinner: QSpinnerFacebook, spinnerColor: 'white', spinnerSize: 90, message: 'Re-Imprimiendo...', messageColor: 'white' })

      const intervalo = setInterval(async () => {
        intentos++;

        try {
          let objeto = { referencia: item.referencia, sistema: item.sistema };

          let variable = ''
          if (this.modo == 'pruebas') {
            variable = 'ReprintXFolio'
          } else {
            variable = 'ReprintXFolioP'
          }

          let response = await axios.post('Spin/' + variable, objeto);
          const data = response.data;

          console.log('Respuesta de re-impresion:', data);

          if (data.jsonr.code && data.jsonr.code === "00") {
            clearInterval(intervalo);
            setTimeout(() => {
              this.$q.loading.hide()

              this.GetUltimoEstado(item.referencia, item.sistema)
              return;
            }, 6000);
          }

          if (intentos >= maxIntentos) {
            clearInterval(intervalo);
            this.$q.loading.hide()

            this.$q.notify({
              type: 'warning',
              message: 'No se recibió confirmación del pago. Intenta más tarde.',
              position: 'top-right'
            });
          }

        } catch (error) {
          clearInterval(intervalo);
          this.$q.loading.hide()

          console.error(error);
          this.$q.notify({
            type: 'negative',
            message: 'Error en le Re-impresión.',
            position: 'top-right'
          });
        }
      }, 3000); // Cada 3 segundos
    },

    async CancelarMovimiento(item) {
      this.drawerLeft = false
      let intentos = 0;
      const maxIntentos = 240;
      
      this.$q.loading.show({ spinner: QSpinnerFacebook, spinnerColor: 'white', spinnerSize: 90, message: 'Cancelando movimiento...', messageColor: 'white' })

      let objeto = { referencia: item.referencia, sistema: item.sistema };

        let variable = ''
        if (this.modo == 'pruebas') {
          variable = 'CancelaT'
        } else {
          variable = 'CancelaTP'
        }

      let response = await axios.post('Spin/' + variable, objeto);
      const data = response.data;

      console.log('Respuesta de cancelacion:', data);

      const intervalo = setInterval(async () => {
        intentos++;

        try {

          if (data.jsonr.code && data.jsonr.code === "00") {
            clearInterval(intervalo);
            setTimeout(() => {
              this.$q.loading.hide()

              this.GetUltimoEstado(item.referencia, item.sistema)
              return;
            }, 6000);
          }

          if (intentos >= maxIntentos) {
            clearInterval(intervalo);
            this.$q.loading.hide()

            this.$q.notify({
              type: 'warning',
              message: 'Error de consulta. Intenta más tarde.',
              position: 'top-right'
            });
          }

        } catch (error) {
          clearInterval(intervalo);
          this.$q.loading.hide()

          console.error(error);
          this.$q.notify({
            type: 'negative',
            message: 'Error en le Re-impresión.',
            position: 'top-right'
          });
        }
      }, 3000); // Cada 3 segundos
    },

//     async CancelarMovimiento(item) {
//   this.drawerLeft = false;

//   const maxIntentos = 240;
//   const intervaloMs = 3000;
//   let intentos = 0;

//   const variable = this.modo === 'pruebas' ? 'CancelaT' : 'CancelaTP';
//   const objeto = { referencia: item.referencia, sistema: item.sistema };

//   this.$q.loading.show({
//     spinner: QSpinnerFacebook,
//     spinnerColor: 'white',
//     spinnerSize: 90,
//     message: 'Cancelando movimiento...',
//     messageColor: 'white'
//   });

//   try {
//     // 🔹 Paso 1: Ejecutar la cancelación solo una vez
//     const { data } = await axios.post(`Spin/${variable}`, objeto);
//     console.log('Respuesta de cancelación:', data);

//     if (data?.jsonr?.code !== "00") {
//       this.$q.loading.hide();
//       this.$q.notify({
//         type: 'warning',
//         message: 'No fue posible cancelar el movimiento.',
//         position: 'top-right'
//       });
//       return;
//     }

//     // 🔹 Paso 2: Iniciar ciclo de verificación si la cancelación fue exitosa
//     this.$q.loading.message = 'Verificando estado de cancelación...';

//     const intervalo = setInterval(async () => {
//       intentos++;

//       try {
//         this.$q.loading.hide();

//         this.GetUltimoEstado(item.referencia, item.sistema);
//          return

//       } catch (error) {
//         clearInterval(intervalo);
//         this.$q.loading.hide();
//         console.error('Error verificando estado:', error);
//         this.$q.notify({
//           type: 'negative',
//           message: 'Error al verificar el estado del movimiento.',
//           position: 'top-right'
//         });
//       }

//     }, intervaloMs);

//   } catch (error) {
//     console.error('Error al cancelar movimiento:', error);
//     this.$q.loading.hide();
//     this.$q.notify({
//       type: 'negative',
//       message: 'Error en la cancelación del movimiento.',
//       position: 'top-right'
//     });
//   }
// },


    async verHistorial() {
      this.drawerLeft = true
      try {
        let response = await axios.get('Spin/GetMovimientos/' + this.terminal);

        this.historial = response.data.lista
        this.drawerLeft = true

        console.log(response)
      } catch (error) {
        console.log(error)
      }
    },
    async CrearCobroSpin() {
      this.mensajeCorrecto = ''
      this.mensajeError = ''

      let msi = null
      if (this.aplicaMeses == false) {
        msi = null
      } else {
        msi = this.msi
      }

      let objeto = {
        cantidad: this.monto,
        terminal: this.terminal,
        sistema: this.sistema,
        id_usuario: this.id_usuario,
        id_venta: this.id_venta,
        msi: msi,
        cadena: this.cadena,
        cadenades: this.cadenades,
      }

      console.log(objeto)
      this.loadingBtnCobro = true
      try {
        let variable = ''
        if (this.modo == 'pruebas') {
          variable = 'CrearCobroSpin'
        } else {
          variable = 'CrearCobroSpinP'
        }

        let response = await axios.post('Spin/' + variable, objeto);
        console.log(response)
        if (response.data.edopet == "0") {
          this.referencia = response.data.referencia
          this.sistema = objeto.sistema
          await this.iniciarConsultaEstado(response.data.referencia, objeto.sistema);
        } else {
          this.loadingBtnCobro = false
          this.$q.notify({ type: 'negative', message: 'Ocurrio un error intentelo de nuevo.', position: 'top-right' })
        }

      } catch (error) {
        this.loadingBtnCobro = false
        console.log(error)
      }
    },

    iniciarConsultaEstado(referencia, sistema) {
      let intentos = 0;
      const maxIntentos = 240; // Esperar hasta 10 minutos

      const intervalo = setInterval(async () => {
        intentos++;

        try {
          let objeto = { referencia, sistema };
          let response = await axios.post('Spin/GetUltimoEstado', objeto);
          const data = response.data;

          console.log('Respuesta:', data);

          if (data.responseCode === "00" || (data.message && data.message.toLowerCase().includes("aprobado"))) {
            clearInterval(intervalo);
            this.loadingBtnCobro = false;
            this.$q.notify({
              type: 'positive',
              message: data.message,
              position: 'top-right',
            });
            this.mensajeCorrecto = data.message
            this.confirmPago = true
            this.monto = 0
            this.montoFormated = 0
            this.aplicaMeses = false
            this.msi = ''
            return;
          } else if (data.responseCode && data.responseCode != "00") {
            clearInterval(intervalo);
            this.loadingBtnCobro = false;
            this.$q.notify({
              type: 'negative',
              message: data.message,
              position: 'top-right'
            });
            this.mensajeError = data.message
            this.confirmPagoError = true

          }

          if (intentos >= maxIntentos) {
            clearInterval(intervalo);
            this.loadingBtnCobro = false;
            this.$q.notify({
              type: 'warning',
              message: 'No se recibió confirmación del pago. Intenta más tarde.',
              position: 'top-right'
            });
          }

        } catch (error) {
          clearInterval(intervalo);
          this.loadingBtnCobro = false;
          console.error(error);
          this.$q.notify({
            type: 'negative',
            message: 'Error al consultar el estado del pago.',
            position: 'top-right'
          });
        }
      }, 3000); // Cada 3 segundos
    },

    cancelarCobro() {
      this.loadingBtnCobro = false;
      this.monto = 0
      this.montoFormated = 0
      this.aplicaMeses = false
      this.msi = ''
    },

    ReprintXFolio() {
      let intentos = 0;
      const maxIntentos = 240;
      this.loadingReimprimir = true
      const intervalo = setInterval(async () => {
        intentos++;

        try {
          let objeto = { referencia: this.referencia, sistema: this.sistema };

          let variable = ''
          if (this.modo == 'pruebas') {
            variable = 'ReprintXFolio'
          } else {
            variable = 'ReprintXFolioP'
          }

          let response = await axios.post('Spin/' + variable, objeto);
          const data = response.data;

          console.log('Respuesta de re-impresion:', data);

          if (data.jsonr.code && data.jsonr.code === "00") {
            clearInterval(intervalo);
            setTimeout(() => {
              this.loadingReimprimir = false
              console.log('esperar')
              this.GetUltimoEstado(this.referencia, this.sistema)
              return;
            }, 6000);
          }

          if (intentos >= maxIntentos) {
            clearInterval(intervalo);
            this.loadingReimprimir = false

            this.$q.notify({
              type: 'warning',
              message: 'No se recibió confirmación del pago. Intenta más tarde.',
              position: 'top-right'
            });
          }

        } catch (error) {
          clearInterval(intervalo);
          this.loadingReimprimir = false

          console.error(error);
          this.$q.notify({
            type: 'negative',
            message: 'Error en le Re-impresión.',
            position: 'top-right'
          });
        }
      }, 3000); // Cada 3 segundos
    },

    async GetUltimoEstado(referencia, sistema) {
      let objeto = { referencia: referencia, sistema: sistema };
      console.log(objeto)
      try {
        let response = await axios.post('Spin/GetUltimoEstado/', objeto);
        console.log(response)
        const data = response.data;
        if (data.responseCode === "00" || (data.message && data.message.toLowerCase().includes("aprobado"))) {
          this.$q.notify({
            type: 'positive',
            message: data.message,
            position: 'top-right',
          });

          this.mensajeCorrecto = data.message
          return;
        } else if (data.responseCode && data.responseCode != "00") {
          this.mensajeError = data.message
          this.$q.notify({
            type: 'negative',
            message: data.message,
            position: 'top-right'
          });
        }
        this.confirmPagoError = true
      } catch (error) {
        console.log(error)
      }
    },

    FormatDate(value) {
      if (typeof value == "string") {
        let fecha_a = value.replace('T', ' ');
        let fecha_b = fecha_a.replace('Z', '');
        const cadenaFechaConHora = fecha_b;
        const fecha = parse(cadenaFechaConHora, 'yyyy-MM-dd HH:mm:ss', new Date());
        const formato = "dd-MMMM-yyyy HH:mm:ss";
        const configuracionLocal = { locale: es };
        let resultado = format(fecha, formato, configuracionLocal);
        return resultado;
      }
      return value;
    },

    formatCurrency(value) {
      return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    },

    formatoMonedaMexicana(valor) {
      const truncado = Math.floor(valor * 100) / 100; // quita los decimales extra sin redondear
      return truncado.toLocaleString('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    EsHoy(fecha) {
    if (!fecha) return false;
    const hoy = new Date();
    const f = new Date(fecha);

    // Compara solo año, mes y día
    return (
      f.getFullYear() === hoy.getFullYear() &&
      f.getMonth() === hoy.getMonth() &&
      f.getDate() === hoy.getDate()
    );
  },
  },
}
</script>
<style>
body {
  background-color: #DEE9FA
}

.doc-note {
  background-color: #f0f4f8;
  /* Fondo claro */
  border-left: 4px solid #007BFF;
  /* Línea de color azul en el borde izquierdo */
  padding: 16px;
  margin: 16px 0;
  border-radius: 8px;
  color: #333;
  /* Color de texto */
  font-family: Arial, sans-serif;
}

.doc-note__title {
  margin: 0 0 8px 0;
  font-weight: bold;
  color: #007BFF;
  /* Mismo tono del borde para coherencia */
  font-size: 16px;
}

.doc-note p {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
}
</style>
